'use client';

export function getCookie(name: string) {
  const doc = typeof document !== 'undefined' ? document : { cookie: '' };
  const value = `; ${doc.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
}
